import styled from 'styled-components'

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-top: var(--safe-area-inset-top, 0px);
  padding-bottom: var(--safe-area-inset-bottom, 0px);
  padding-left: var(--safe-area-inset-left, 0px);
  padding-right: var(--safe-area-inset-right, 0px);
`

export const HeaderContainer = styled.div`
  height: 72px;
`

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 12px;
  gap: 14px;
  box-sizing: border-box;
  background: var(--Background-Gradient-Primary-2, linear-gradient(135deg, #3c37cb 0%, #2d2e82 100%));
`

export const MainContainer = styled.div`
  flex: 1;
  display: flex;
`
